// @ts-check

/**
 * Shows or hides a page description. The help button reports the new state.
 *
 * @param {Element} button
 * @param {Element} panel
 */
export function togglePageHelp(button, panel) {
  const willOpen = panel.getAttribute('hidden') != null;
  if (willOpen) panel.removeAttribute('hidden');
  else panel.setAttribute('hidden', '');
  button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
}

/**
 * Wires every `.page-help-btn` to the description named by `aria-controls`.
 *
 * @param {ParentNode & { getElementById?: (id: string) => Element|null }} [root]
 */
export function bindPageHelpToggles(root = document) {
  root.querySelectorAll('.page-help-btn').forEach((node) => {
    if (!node || typeof (/** @type {any} */ (node)).getAttribute !== 'function') return;
    const button = /** @type {Element} */ (node);
    const id = button.getAttribute('aria-controls') || '';
    const panel = id ? root.querySelector('#' + id) : null;
    if (!panel) return;
    button.addEventListener('click', () => togglePageHelp(button, panel));
  });
}
